import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ClientPartnerService } from '../../../_services/client-partner.service';
import { ClientPartner } from '../../../_models/client-partner';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-clients-partners-list',
    templateUrl: './clients-partners-list.component.html',
    styleUrls: ['./clients-partners-list.component.css'],
    standalone: false
})
export class ClientsPartnersListComponent implements OnInit {
    title = 'Clients & Partners';
    loading = true;
    clientPartners: ClientPartner[] = [];
    showDeleteModal = false;
    showDetailsModal = false;
    partnerToDelete: ClientPartner | null = null;
    selectedPartner: ClientPartner | null = null;
    loadingDetails = false;

    constructor(
        private clientPartnerService: ClientPartnerService,
        private titleService: Title,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.titleService.setTitle(this.title);
    }

    ngOnInit() {
        this.loadClientPartners();
    }

    loadClientPartners() {
        this.loading = true;
        this.clientPartnerService.loadAllAdmin().subscribe({
            next: (response: any) => {
                const partners = response.data?.data || response.data || response || [];
                this.clientPartners = partners.map((partner: any) => ({
                    ...partner,
                    logoPath: this.getFullLogoUrl(partner.logoPath)
                }));
                this.loading = false;
            },
            error: () => {
                this.toastr.error('Failed to load clients and partners');
                this.loading = false;
            }
        });
    }

    getFullLogoUrl(path: string): string {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        return `${environment.apiUrl}/${path}`;
    }

    addPartner() {
        this.router.navigateByUrl('/admin/client-partner/add');
    }

    editPartner(partner: ClientPartner) {
        this.router.navigate(['/admin', 'client-partner', partner.id, 'edit']);
    }

    viewDetails(partner: ClientPartner) {
        this.selectedPartner = partner;
        this.showDetailsModal = true;
        this.loadingDetails = true;

        this.clientPartnerService.loadOne(partner.id).subscribe({
            next: (response: any) => {
                const data = response.data || response;
                this.selectedPartner = {
                    ...data,
                    logoPath: this.getFullLogoUrl(data.logoPath)
                };
                this.loadingDetails = false;
            },
            error: () => {
                this.loadingDetails = false;
                this.toastr.error('Failed to load partner details');
            }
        });
    }

    closeDetails() {
        this.showDetailsModal = false;
        this.selectedPartner = null;
    }

    editFromModal() {
        if (this.selectedPartner) {
            this.router.navigate(['/admin', 'client-partner', this.selectedPartner.id, 'edit']);
            this.closeDetails();
        }
    }

    confirmDelete(partner: ClientPartner) {
        this.partnerToDelete = partner;
        this.showDeleteModal = true;
    }

    cancelDelete() {
        this.showDeleteModal = false;
        this.partnerToDelete = null;
    }

    deletePartner() {
        if (!this.partnerToDelete) return;

        this.clientPartnerService.delete(this.partnerToDelete.id).subscribe({
            next: () => {
                this.toastr.success('Partner deleted successfully');
                this.showDeleteModal = false;
                this.partnerToDelete = null;
                this.loadClientPartners();
            },
            error: () => {
                this.toastr.error('Failed to delete partner');
                this.showDeleteModal = false;
                this.partnerToDelete = null;
            }
        });
    }
}
